module.exports = __webpack_public_path__ + "static/media/bg.88df21e2.jpg";